// extracted by mini-css-extract-plugin
export var wrapper = "Sidebar-module--wrapper--KJAWz";